import { render, staticRenderFns } from "./CMApplicationSettingsPage.vue?vue&type=template&id=f23708e0&scoped=true&"
import script from "./CMApplicationSettingsPage.vue?vue&type=script&lang=js&"
export * from "./CMApplicationSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./CMApplicationSettingsPage.vue?vue&type=style&index=0&id=f23708e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23708e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f23708e0')) {
      api.createRecord('f23708e0', component.options)
    } else {
      api.reload('f23708e0', component.options)
    }
    module.hot.accept("./CMApplicationSettingsPage.vue?vue&type=template&id=f23708e0&scoped=true&", function () {
      api.rerender('f23708e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/CMApplicationSettingsPage.vue"
export default component.exports